import { useState, useEffect } from "react";
import axios from "axios";
import { Container, Table, Spinner } from "react-bootstrap";
import { CSVLink } from "react-csv";
import Pagination from "../Pagination/Pagination";

export default function ListExams(props) {
  const API_URL = process.env.REACT_APP_BACKEND_URL + "/api";
  const ls = require("localstorage-ttl");
  const [isLoading, setLoading] = useState(false);
  const [users, setUsers] = useState([]);
  const token = JSON.parse(ls.get("jwt"));

  const PAGE_SIZE = 50;
  const [currentPage, setCurrentPage] = useState(1);
  const [pagination, setPagination] = useState({});
  const [pageUsers, setPageUsers] = useState([]);

  useEffect(() => {
    users.length === 0 ? GetUsers() : FilterUsers(users, currentPage);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentPage]);

  const headerRequest = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };

  const FilterUsers = (users, page) => {
    setPageUsers(
      users.filter(
        (u, idx) => idx >= (page - 1) * PAGE_SIZE && idx < page * PAGE_SIZE
      )
    );
  };

  const GetUsers = () => {
    setLoading(true);
    axios
      .get(
        `${API_URL}/users?populate=exams.grade,exams.dojo,exams.examiner&sort[0]=lastname&pagination[pageSize]=2000`,
        headerRequest
      )
      .then((users) => {
        let exams = [];
        for (let i = 0; i < users.data.length; i++) {
          const u = users.data[i];
          for (let j = 0; j < u.exams.length; j++) {
            const e = u.exams[j];
            let x = {
              id: u.id,
              docNumber: u.docNumber,
              fullname: u.lastname + ", " + u.name,
              examId: e.id,
              date: e.date,
              datePaid: e.datePaid,
              dojoId: e.dojo?.id,
              dojo: e.dojo?.name,
              gradeId: e.grade?.id,
              grade: e.grade?.name,
              examiner: e.examiner?.docNumber,
              idAikikai: e.idAikikai,
              dateAikikai: e.dateAikikai,
            };
            exams.push(x);
          }
        }
        setUsers(exams);
        setPagination({ total: exams.length });
        FilterUsers(exams, 1);
        setLoading(false);
      });
  };

  const renderData = (
    <>
      <Table striped hover size="sm" responsive="sm">
        <thead>
          <tr>
            <th>ID</th>
            <th>DNI</th>
            <th>Nombre</th>
            <th>ID Examen</th>
            <th>Fecha</th>
            <th>Grade</th>
          </tr>
        </thead>
        <tbody>
          {!users || users.length < 1 ? (
            <tr>
              <td colSpan="7" align="center">
                No hay datos.
              </td>
            </tr>
          ) : (
            pageUsers.map((u, index) => (
              <tr key={index}>
                <td align="center">{u.id}</td>
                <td align="center">{u.docNumber}</td>
                <td align="left">{u.fullname}</td>
                <td align="center">{u.examId}</td>
                <td align="center">{u.date}</td>
                <td align="center">{u.grade}</td>
              </tr>
            ))
          )}
        </tbody>
      </Table>
      <Pagination
        className="pagination-bar"
        currentPage={currentPage}
        totalCount={pagination.total}
        pageSize={PAGE_SIZE}
        onPageChange={(page) => setCurrentPage(page)}
      />
    </>
  );

  return (
    <Container className="p-3 mb-4 bg-light rounded-3">
      <h4>EXPORTAR EXÁMENES</h4>
      {!isLoading && users && users.length > 1 ? (
        <CSVLink
          data={users}
          filename={"faa-exams.csv"}
          className="btn btn-success btn-sm"
        >
          DESCARGAR
        </CSVLink>
      ) : null}
      {isLoading ? <Spinner animation="border" /> : renderData}
    </Container>
  );
}
